const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "会社紹介",
    "termsOfService": "利用規約",
    "privacyPolicy": "プライバシーポリシー",
    "guaranteeOfRights": "データ主体の権利",
    "customerSupport": "お問い合わせ",
    "cookiePolicy": "クッキーポリシー",
    "declarationOfSafety": "安心・安全宣言",
    "youthProtectionPolicy": "青少年保護政策",
    "communityPolicy": "コミュニティポリシー",
    "probability": "probability",
    "operationPolicy": "運営ポリシー",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "ゲームレーティング",
    "communityPolicyView": "コミュニティ運営ポリシー",
    "servicePolicy": "서비스정책",
    "termsOfUse": "会員ポリシー",
    "operationPolicyNCJ": "運営方針",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "特定商取引法に基づく表記",
    "settlementFund": "資金決済法に基づく表示",
    "serviceTerm": "サービス利用約款",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NCサービス同意",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "ゲーム関連法律に基づく追加表記",
    "brandInformation": "商号情報",
    "copyright": "著作権情報",
    "channelingInfo": "㈱NCはplaync内チャネリングサービスの提供を仲介する通信販売仲介業者であり、通信販売の当事者ではありません。<br>チャンリングサービスの提供に関連したすべての義務と責任は個別の通信販売事業者にあり、これに関連して発生した問題に対して、当社は責任を負いません。"
  },
  "infoCS": {
    "businessInformation": "事業者情報確認",
    "infoAddress": "事業者名 ㈱NC 共同代表 キム・テクジン、パク・ビョンム 事業者登録番号 220-81-43000 E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020 FAX +82-2-2186-3550",
    "pc": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020 FAX +82-2-2186-3550",
    "ncfamilyzone": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020 FAX +82-2-2186-3550",
    "other": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020 FAX +82-2-2186-3550",
    "none": "",
    "infoEmail": "Eメール",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PCゲーム)/MobileCS@ncsoft.com/(モバイルゲーム)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "タイトル",
    "jpGenre": "ジャンル",
    "jpPrice": "価格",
    "jpPriceValue": "基本無料 (アイテム課金あり)",
    "jpOs": "対応OS",
    "jpPlatform": "対応プラットフォーム",
    "jpDevelopedBy": "開発/運営",
    "jpReleaseDay": "リリース日",
    "jpReleaseDayValue_LW": "2021年11月4日"
  },
  "country": {
    "KR": "大韓民国",
    "TW": "台湾",
    "RU": "ロシア",
    "MY": "マレーシア",
    "SA": "サウジアラビア",
    "SG": "シンガポール",
    "AE": "アラブ首長国連邦",
    "ID": "インドネシア",
    "JP": "日本",
    "QA": "カタール",
    "TH": "タイ",
    "PH": "フィリピン",
    "HK": "香港",
    "UA": "ウクライナ",
    "BY": "ベラルーシ",
    "LT": "リトアニア",
    "PL": "ポーランド",
    "GR": "ギリシャ",
    "IL": "イスラエル",
    "KW": "クウェート",
    "AT": "オーストリア",
    "US": "アメリカ",
    "CA": "カナダ",
    "DE": "ドイツ",
    "GB": "英国",
    "FR": "フランス",
    "BR": "ブラジル",
    "IT": "イタリア",
    "ES": "スペイン",
    "CL": "チリ",
    "NO": "ノルウェー",
    "SE": "スウェーデン",
    "IE": "アイルランド",
    "PT": "ポルトガル",
    "FI": "フィンランド",
    "DK": "デンマーク",
    "CH": "スイス",
    "AR": "アルゼンチン",
    "PE": "ペルー",
    "MX": "メキシコ",
    "KZ": "カザフスタン",
    "UZ": "ウズベキスタン",
    "AZ": "アゼルバイジャン",
    "GE": "ジョージア",
    "MD": "モルドバ",
    "AM": "アルメニア",
    "MO": "マカオ",
    "IN": "インド",
    "PK": "パキスタン",
    "NL": "オランダ",
    "RO": "ルーマニア",
    "AU": "オーストラリア",
    "TR": "テュルキエ",
    "EC": "エクアドル",
    "CO": "コロンビア",
    "ZA": "南アフリカ共和国",
    "EG": "エジプト",
    "NC": "Global"
  }
};

export default l10n;
